import api from "../../api/api";


const submitMessage = (payload) =>{
    return new Promise((resolve, reject)=>{
        api.post("/web-chatbot/message",payload).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}


const chatbotServices = {
    submitMessage
}

export default chatbotServices